import { values } from 'lodash';

import { RootState } from 'src/state/rootReducer';

export const getUtilities = (state: RootState) => {
  return values(state.entities.utilities.byId);
};
